import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state, payload, result) {
  const statuses = state.chapterStatuses || {}
  const newState = {
    ...state,
    chapterStatuses: {
      ...statuses,
      [result.userId]: {
        ...statuses[result.userId],
        [result.kapitelId]: {
          id: result.kapitelId,
          status: result.status,
          lastStatusChange: result.lastStatusChange,
        },
      },
    },
    isLoading: false,
  }
  return newState
}

export function rejected(state, payload, error) {
  return {
    ...state,
    isLoading: false,
    ausbildungsPlanError: error && error.message ? error.message : i18n.t('misc_unknown_error'),
  }
}

export async function action(payload) {
  try {
    return await Api.getChapterStatusById(payload.chapterId)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
